import { $form, $view } from 'signals/global.signals';
import getSelectValue from 'utils/getSelectValue';
import * as dealsApi from 'api/deals.api';
import displayError from 'utils/displayError';
import displayNotification from 'utils/displayNotification';

export const handleSubmitDealCreate = async () => {
  $view.update({
    isLoading: true,
  });
  const formData = {
    name: $form.value.name,
    investmentStage: getSelectValue($form.value.investmentStage),
    typeOfRaise: getSelectValue($form.value.typeOfRaise),
    currentValue: $form.value.currentValue,
    currentRaiseSize: $form.value.currentRaiseSize,
    amountCommitted: $form.value.amountCommitted,
    minimumInvestment: $form.value.minimumInvestment,
    fundingDate: $form.value.fundingDate,
    usesOfCapital: $form.value.usesOfCapital,
    preMoneyValuation: $form.value.preMoneyValuation,
    amountPreviouslyRaised: $form.value.amountPreviouslyRaised,
    valuationLastRound: $form.value.valuationLastRound,
    cap: $form.value.cap,
    discountPercent: $form.value.discountPercent,
    interestRate: $form.value.interestRate,
    isMrrIncluded: $form.value.isMrrIncluded,
    isArrIncluded: $form.value.isArrIncluded,
    isCashOnHandIncluded: $form.value.isCashOnHandIncluded,
    isCurrent: $form.value.isCurrent,
    filesToInclude: getSelectValue($form.value.dataVaultInclusion) === 'select' ? $form.value.filesToInclude : [],
    isActive: $form.value.isActive,
    isPublic: $form.value.isPublic,
    isIncludeAllDocuments: getSelectValue($form.value.dataVaultInclusion) === 'all',
  };
  try {
    const deal = await dealsApi.createDeal(formData);
    displayNotification({ message: 'Deal created successfully', title: 'Deal Created' });
    window.location.href = `/founder/deals/${deal.id}`;
  } catch (error) {
    displayError({
      message: 'Failed to create deal. Please check your information and try again.',
      title: 'Deal Creation Error',
    });
  } finally {
    $view.update({
      isLoading: false,
    });
  }
};
